// class CartRecommendations {
//   constructor() {
//     this.slider = document.querySelector(".cart-rec-track");

//     if (!this.slider) return;

//     this.cards = [...this.slider.children];
//     this.prev = document.querySelector(".cart-rec-prev");
//     this.next = document.querySelector(".cart-rec-next");

//     this.index = 0;

//     this.bindEvents();
//   }

//   bindEvents() {
//     this.prev?.addEventListener("click", () => this.prevSlide());
//     this.next?.addEventListener("click", () => this.nextSlide());

//     document.querySelectorAll(".cart-rec-add").forEach((button) => {
//       button.addEventListener("click", (e) => this.addToCart(e));
//     });
//   }

//   nextSlide() {
//     if (this.index >= this.cards.length - 1) return;

//     this.index++;

//     this.slider.style.transform = `translateX(-${this.index * 100}%)`;
//   }

//   prevSlide() {
//     if (this.index <= 0) return;

//     this.index--;

//     this.slider.style.transform = `translateX(-${this.index * 100}%)`;
//   }

//   addToCart(event) {
//     const button = event.currentTarget;

//     button.disabled = true;
//     button.innerText = "Adding...";

//     fetch(`${window.Shopify.routes.root}cart/add.js`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json"
//       },
//       body: JSON.stringify({
//         items: [
//           {
//             id: button.dataset.variantId,
//             quantity: 1
//           }
//         ]
//       })
//     })
//       .then(() => this.refreshCart())
//       .catch(console.error)
//       .finally(() => {
//         button.disabled = false;
//         button.innerText = "Add to Cart";
//       });
//   }

//   refreshCart() {
//     fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
//       .then((response) => response.text())
//       .then((html) => {
//         const doc = new DOMParser().parseFromString(html, "text/html");

//         const newDrawer = doc.querySelector("cart-drawer");
//         const currentDrawer = document.querySelector("cart-drawer");

//         if (!newDrawer || !currentDrawer) return;

//         currentDrawer.innerHTML = newDrawer.innerHTML;
//       });
//   }
// }

// document.addEventListener("DOMContentLoaded", () => {
//   new CartRecommendations();
// });

document.addEventListener('click', async (e) => {
  const button = e.target.closest('.cart-rec-add');
  if (!button) return;

  e.preventDefault();

  const variantId = button.dataset.id;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const response = await fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });

    const parsedState = await response.json();

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.renderContents(parsedState);
    }
  } catch (error) {
    console.error(error);
  } finally {
    button.disabled = false;
    button.textContent = 'Add to Cart';
  }
});